angular.module('zc.zenclerkS')
  .controller('ZcsSetupSiteController', ZcsSetupSiteController);

ZcsSetupSiteController.$inject = ['$rootScope', 'Project', 'ZcsOemService', 'project'];
function ZcsSetupSiteController($rootScope, Project, ZcsOemService, project) {
  const vm = this;

  // variables
  vm.project = _.merge({}, project);
  vm.isOemService = ZcsOemService.isOemService();

  // actions
  vm.save = save;

  activate();

  function activate() {
  }

  function save() {
    vm.project.siteinfo_confirmed = true;
    Project.update({ projectId: `apikey:${vm.project.apikey}` }, { project: vm.project })
      .then(result => {
        vm.project = _.merge(vm.project, result);
        $rootScope.$broadcast('siteSetup.nextStep');
      });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/setup/setup_site.controller.js